/**
 * Configuration pour la génération de PDF haute qualité
 *
 * Ce fichier centralise les paramètres de qualité pour l'export PDF
 * afin d'assurer une résolution optimale (300 DPI) pour l'impression professionnelle.
 */

/**
 * Facteur d'échelle pour atteindre 300 DPI
 *
 * Calcul : 300 DPI (impression) / 72 DPI (web standard) = 4.166...
 * Arrondi à 4 pour optimiser les performances tout en maintenant une excellente qualité
 */
export const HIGH_QUALITY_SCALE = 4;

/**
 * Offset horizontal pour compenser le décalage causé par le transform scale
 * Ajusté manuellement pour centrer correctement le contenu
 */
export const SCALE_OFFSET_LEFT = "-115px";

/**
 * Options pour dom-to-image avec qualité maximale
 *
 * @param element - L'élément HTML à capturer
 * @param scale - Le facteur d'échelle (par défaut HIGH_QUALITY_SCALE)
 * @returns Options configurées pour domtoimage
 */
export const getDomToImageOptions = (
  element: HTMLElement,
  scale: number = HIGH_QUALITY_SCALE,
  offsetLeft: string = SCALE_OFFSET_LEFT
) => {
  return {
    bgcolor: "transparent",
    quality: 1, // Qualité maximale
    cacheBust: true,
    useCORS: true,
    // Dimensions multipliées par le facteur d'échelle pour augmenter la résolution
    width: element.offsetWidth * scale,
    height: element.offsetHeight * scale,
    // Transform scale avec offset pour centrer correctement le contenu
    style: {
      transform: `scale(${scale})`,
      transformOrigin: "0 0",
      width: `${element.offsetWidth}px`,
      height: `${element.offsetHeight}px`,
      position: "relative",
      left: offsetLeft,
      top: "0",
    } as any,
    filter: () => true,
  };
};

/**
 * Options jsPDF pour haute qualité
 */
export const getJsPDFOptions = () => {
  return {
    orientation: "portrait" as const,
    unit: "mm" as const,
    format: "a4" as const,
    compress: false, // Désactiver la compression pour préserver la qualité
    precision: 2, // Précision maximale pour les calculs
  };
};

/**
 * Compression d'image pour jsPDF
 * 'SLOW' préserve la meilleure qualité
 */
export const PDF_IMAGE_COMPRESSION = "SLOW" as const;

/**
 * Informations sur les DPI
 */
export const DPI_INFO = {
  web: 72, // DPI standard pour affichage web
  print: 300, // DPI requis pour impression professionnelle
  scale: HIGH_QUALITY_SCALE, // Facteur multiplicateur
} as const;
